<template>
    <!--弹窗-->
    <el-dialog width="400px" title="添加备注" :visible.sync="visible" :before-close="handleClose">
        <el-form v-loading="loading" ref="formData" :model="formData">
            <div class="media-txt"><span style="font-weight: 900;">日期</span>：{{formData.date}}</div>
            <div class="media-txt"><span style="font-weight: 900;">排名</span>：{{formData.Position}}</div>
            <el-form-item prop="asin">
                <el-input v-model="formData.remark" style="width:360px;" type="textarea" maxlength="50" :rows="6" placeholder="请输入备注" @input="change()"></el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        change() {
            this.$forceUpdate();
        },
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true;
                    api.remark_in_date(this.formData)
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "添加成功"
                                });
                                this.handleClose(false);
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                type: "error",
                                message:
                                    "网络出现问题，请查看数据是否添加完成！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow, this.formData.id);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.media-txt {
    font-size: 13px;
    color: #6a6c6f;
    margin: 5px 0 15px 0;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 6px !important;
}
</style>
